import {mapGetters} from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'getReservionStates',
            'getPaymentsStatusList'
        ])
    },
    methods: {
        trackFilter: function (filterName, filterArea, filterObj){
            if(!filterArea){
                console.log('Mixpanel mixin must have a "trackFilter"', filterArea);
            }

            let objectToTrack = {
                'Filter Area': filterArea,
                'Product': filterObj['s.ProductId']? 1 : 0,
                'Event': filterObj['s.eventId']? 1 : 0,
                'Resource': filterObj['s.ResourceId']? 1 : 0,
                'Country': filterObj['s.countryId']? 1 : 0,
                'Seller My Team': filterObj['s.userAccountId']? 1 : 0,
                'Seller Agent': filterObj['s.agentId']? 1 : 0,
                'Custom Text': filterObj['s.String']? 1 : 0,
                'Reservation Status': filterObj['s.Status']? this.getReservionStates.filter(s => {return s.id == filterObj['s.Status']})[0].description : null,
                'Payment Status': filterObj['s.PaymentStatus']? this.getPaymentsStatusList.filter(s => {return s.id == filterObj['s.PaymentStatus']})[0].label : null,
            }

            this.$ma.trackEvent({action:filterName, properties: objectToTrack})
            // console.log('sending this to mixpanel', filterName, objectToTrack);
        },
        trackSaveChanges: function(itemType, itemId, itemName) {
            if(!itemType){
                console.log('Mixpanel mixin must have a "itemType"');
            }

            let objectToTrack = {
                'id': itemId,
                'name': itemName
            }

            this.$ma.trackEvent({action:'Save '+itemType, properties: objectToTrack})
            // console.log('sending this to mixpanel', filterName, objectToTrack);
        },
        trackDownloadReport: function (report) {
            if(!report){
                console.log('Mixpanel mixin must have a "report"');
            }

            let objectToTrack = {
                'id': report.id,
                'name': report.name,
            }

            this.$ma.trackEvent({action:'Download Report', properties: objectToTrack})
        },
        trackUserAction: function (actionName, actionObject) {
            // this can be used to track simple info, just add an actionName and actionObject
            if(!actionName){
                console.log('Mixpanel mixin must have a "actionName"');
            }

            this.$ma.trackEvent({action:actionName, properties: actionObject})
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/mixpanel.js